import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\Root\\Documents\\source\\law\\frontend\\src\\app\\(site)\\expertise\\[slug]\\SingleService.tsx");
